import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, } from 'reactstrap';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import { baseURL, AGENTEKEYWORD, CONFIG } from '../../configs/exports';
import Select from 'react-select'
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from 'react-datepicker'; // Import react-datepicker
import "react-datepicker/dist/react-datepicker.css"; // Import styles
import { enZA } from 'date-fns/locale'; // Import African locale


export class NewlyCustomersCount extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);


        this.columns = [
            {
                key: "msisdn",
                TrOnlyClassName: 'tsc',
                text: "Customer",
                className: "tsc",
                align: "left"
            },
            {
                key: "ussd",
                TrOnlyClassName: 'tsc',
                text: "USSD",
                className: "tsc",
                align: "left"
            },

            {
                key: "channel",
                TrOnlyClassName: 'tsc',
                text: "Channel",
                className: "tsc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            }
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [20000, 30000, 50000],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 20000,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                // print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
        let now = new Date();
        let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end,
            isPageLoad: true,
            isDownloading: false,
            channel: "0",
            ussd: 885,
            startDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
            startTime: '00:00',
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            endTime: '23:59',
            terms_channel: [
                {
                    label: '885',
                    value: '885'
                },
                {
                    label: '538',
                    value: '538'
                }
                ,
                {
                    label: '599',
                    value: '599'
                }
            ]

        }
    }
    componentDidMount() {
        // Default range is the current month: first day of month -> today
        const startDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
        const endDate = moment(new Date()).format('YYYY-MM-DD');

        this.setState({
            startDate: startDate,
            endDate: endDate,
            startTime: '00:00',
            endTime: '23:59',
            isPageLoad: true,
            valuedate: "This Month"
        })


        localStorage.setItem("STARTDATE", startDate + " 00:00:00")
        localStorage.setItem("ENDDATE", endDate + " 23:59:59")

        this.getData("", startDate + " 00:00:00", endDate + " 23:59:59")
    }

    getData = (queryString = "", startDate, endDate) => {
        // eslint-disable-next-line
        let url = baseURL + `per_day_report?presenter=${this.state.channel}&ussd=${this.state.ussd}&startTime=` + startDate + "&endTime=" + endDate + "&" + queryString

        // alert(url)
        console.log(url)
        this.setState({
            isLoading: true,
        })
        const config = CONFIG

        // alert(url)
        axios.all([
            axios.get(url, config),
        ]).then(axios.spread((branchResponse,) => {
            this.setState({
                admins: branchResponse.data.data,
                mdata: branchResponse.data.total,
                isLoading: false,
            },
                function () {
                    var data = [];
                    console.log("BUG", this.state.admins)

                    if (this.state.admins.length > 0) {
                        for (let i = 0; i < this.state.admins.length; i++) {
                            let date = { dates: moment.utc(this.state.admins[i].created_on).format('YYYY-MM-DD HH:mm:ss') };
                            data.push(Object.assign(date, this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                        console.log("bugs", data);
                    }
                }
            );
        }))
    }


    applyCallback(startDate, endDate) {

        localStorage.setItem("STARTDATE", startDate)
        localStorage.setItem("ENDDATE", endDate)
        let Sdate1 = moment(startDate).format('DD MMM, YYYY');
        let Edate2 = moment(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })



        this.getData("", moment(startDate).format('YYYY-MM-DD') + " 00:00:00", moment(endDate).format('YYYY-MM-DD') + " 23:59:59");
    }

    handleChangeDate = (date) => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD')
        });
    };


    handleChangeTmeDate = (date) => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD')
        });
    };

    handleSearch = (e) => {
        e.preventDefault();

        const { startDate, startTime, endDate, endTime } = this.state;

        // Combine date and time into a full datetime string
        const start = `${startDate} ${startTime}`;
        const end = `${endDate} ${endTime}`;

        // Format the date-time strings using Moment.js
        const formattedStart = moment(start).format('YYYY-MM-DD HH:mm:ss');
        const formattedEnd = moment(end).format('YYYY-MM-DD HH:mm:ss');

        localStorage.setItem("STARTDATE", formattedStart)
        localStorage.setItem("ENDDATE", formattedEnd)

        // Call the getData function with formatted start and end
        this.getData("", formattedStart, formattedEnd);
    }


    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString, moment(localStorage.getItem("STARTDATE")).format('YYYY-MM-DD HH:mm:ss'), moment(localStorage.getItem("ENDDATE")).format('YYYY-MM-DD HH:mm:ss'))


    }

    getDataUpdate() {
        const startDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
        const endDate = moment(new Date()).format('YYYY-MM-DD');
        this.getData("", startDate + " 00:00:00", endDate + " 23:59:59")
    }

    downloadCsv = () => {
        const { startDate, startTime, endDate, endTime } = this.state;
        const startTimeParam = moment(`${startDate} ${startTime}`).format('YYYY-MM-DD HH:mm:ss');
        const endTimeParam = moment(`${endDate} ${endTime}`).format('YYYY-MM-DD HH:mm:ss');

        this.setState({ isDownloading: true });

        axios.get(baseURL + 'download_csv', {
            ...CONFIG,
            responseType: 'blob',
            params: {
                presenter: this.state.channel,
                ussd: this.state.ussd,
                startTime: startTimeParam,
                endTime: endTimeParam,
            },
        }).then((response) => {
            const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `per_day_report_${startDate}_to_${endDate}.csv`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
            this.setState({ isDownloading: false });
        }).catch((error) => {
            console.error("CSV download failed", error);
            this.setState({ isDownloading: false });
        });
    }



    refetchWithRange = () => {
        const { startDate, startTime, endDate, endTime } = this.state;
        const start = moment(`${startDate} ${startTime}`).format('YYYY-MM-DD HH:mm:ss');
        const end = moment(`${endDate} ${endTime}`).format('YYYY-MM-DD HH:mm:ss');
        this.getData("", start, end);
    }

    handleChangeChannel = value => {
        if (value != null) {
            this.setState({ ussd: value.value }, this.refetchWithRange)
        } else {
            this.setState({ ussd: '' })
        }
    }

    handleChangeChannelDD = value => {
        if (value != null) {
            this.setState({ channel: value }, this.refetchWithRange)
        } else {
            this.setState({ channel: '' })
        }
    }

    render() {
        let ranges = {
            "Today Only": [moment(this.state.start), moment(this.state.end)],
            "Yesterday Only": [
                moment(this.state.start).subtract(1, "days"),
                moment(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment(this.state.start).subtract(3, "days"), moment(this.state.end)],
            "5 Days": [moment(this.state.start).subtract(5, "days"), moment(this.state.end)],
            "1 Week": [moment(this.state.start).subtract(7, "days"), moment(this.state.end)],
            "2 Weeks": [moment(this.state.start).subtract(14, "days"), moment(this.state.end)],
            "1 Month": [moment(this.state.start).subtract(1, "months"), moment(this.state.end)],
            "1 Year": [moment(this.state.start).subtract(1, "years"), moment(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY",
            "sundayFirst": false
        }

        const { startDate, startTime, endDate, endTime } = this.state;

        return (
            <div >
                < >
                    <h4>No of Customers Per Day</h4>
                    < Card >
                        <CardBody >
                            <div className="col-6 float-right">
                                <button
                                    className="float-right btn btn-primary btn-bg"
                                    type="button"
                                    onClick={this.downloadCsv}
                                    disabled={this.state.isDownloading}
                                >
                                    {this.state.isDownloading ? 'Downloading…' : 'DOWNLOAD ALL'}
                                </button>
                            </div>

                            <form onSubmit={this.handleSearch}>
                                <div className="row align-items-end mb-4">
                                    {/* Start Date Picker */}
                                    <div className="col-md-2 col-sm-3">
                                        <label className="form-label">Start Date</label>
                                        <DatePicker
                                            selected={startDate ? new Date(startDate) : null}
                                            onChange={(date) => this.handleChangeDate(date, 'startDate')}
                                            dateFormat="yyyy-MM-dd"
                                            locale={enZA}
                                            className="form-control"
                                        />
                                    </div>

                                    {/* Start Time Picker */}
                                    <div className="col-md-2 col-sm-3">
                                        <label className="form-label">Start Time</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            name="startTime"
                                            value={startTime}
                                            onChange={(e) => this.setState({ startTime: e.target.value })}
                                        />
                                    </div>

                                    {/* End Date Picker */}
                                    <div className="col-md-2 col-sm-3">
                                        <label className="form-label">End Date</label>
                                        <DatePicker
                                            selected={endDate ? new Date(endDate) : null}
                                            onChange={(date) => this.handleChangeTmeDate(date, 'endDate')}
                                            dateFormat="yyyy-MM-dd"
                                            locale={enZA}
                                            className="form-control"
                                        />
                                    </div>

                                    {/* End Time Picker */}
                                    <div className="col-md-2 col-sm-3">
                                        <label className="form-label">End Time</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            name="endTime"
                                            value={endTime}
                                            onChange={(e) => this.setState({ endTime: e.target.value })}
                                        />
                                    </div>

                                    {/* Search Button */}
                                    <div className="col-md-2 col-sm-3">
                                        <button type="submit" className="btn btn-primary w-100">
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </form><br />
                            <div className="panel-body" >
                                <div >
                                    Newly Recruited Customers: <b>{this.state.mdata}</b>

                                </div>
                                <br />



                                <div className="col-md-4">

                                    <label className="form-label">Enter Channel</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="channel"
                                        value={this.state.channel}
                                        onChange={(e) => this.handleChangeChannelDD(e.target.value)}
                                    />

                                </div>
                                <br></br>
                                <br />
                                {/* <div className="col-md-4">

                                    <Select
                                        isClearable
                                        options={this.state.terms_channel}
                                        placeholder="Select USSD"
                                        autosize={true}
                                        onChange={this.handleChangeChannel}
                                        className="selected"
                                        menuPortalTarget={document.body}
                                        name="namffe"
                                    />
                                </div> */}


                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.data}
                                    columns={this.columns}
                                    dynamic={true}
                                    id="tsc"
                                    loading={this.state.isLoading}
                                    total_record={this.state.mdata}
                                    onChange={this.tableChangeHandler} />
                            </div>
                        </CardBody>

                    </Card>
                </>
            </div>

        )
    }
}